<template>
  <a-layout-header class="no-print" :class="[theme, fixedHeader, 'global-header']" :style="{width: getHeadWidth}">
    <div :class="['global-header-wide', layout]">
      <div :class="['logo',theme]">
        <img width="372" src="@/assets/logo.png">
        <h1>{{systemName}}</h1>
      </div>
      <div class="global-header-right">
        <img src="../assets/user-portrait.png" alt="">
        <a-dropdown :trigger="['hover']" placement="bottomRight">
          <span class="user-name">{{username}}，欢迎您！</span>
          <a-menu slot="overlay" @click="handleRoleClick">
            <a-menu-item v-for="role in roles" :key="role.id" :class="{'active-role': role.id === currentRoleId}">
              <a-icon v-if="role.id === currentRoleId" type="check" />
              {{ role.name }}
            </a-menu-item>
          </a-menu>
        </a-dropdown>
        <span class="logout" @click="handleLogout">
          <a-icon type="logout"/>
        </span>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
export default {
  name: 'GlobalHeader',
  props: ['collapsed', 'menuData', 'roles', 'currentRoleId'],
  computed: {
    layout () {
      return this.$store.state.setting.layout
    },
    theme () {
      return this.layout === 'side' ? 'light' : this.$store.state.setting.theme
    },
    fixedHeader () {
      return this.$store.state.setting.fixedHeader ? 'fixed-header' : ''
    },
    getHeadWidth () {
      const { isMobile, fixedHeader, layout } = this.$store.state.setting
      if (isMobile || !fixedHeader || layout === 'head') {
        return '100%'
      }
      return this.collapsed ? 'calc(100% - 80px)' : 'calc(100% - 256px)'
    },
    systemName () {
      return this.$store.state.setting.systemName
    }
  },
  data () {
    return {
      username: ''
    }
  },
  mounted () {
    this.fetchUsername()
  },
  methods: {
    toggleCollapse () {
      this.$emit('toggleCollapse')
    },
    fetchUsername () {
      this.$axios.post('/api/common/getXmAndSjh.do', { op: '' }).then(res => {
        this.username = res.data.data || ''
      })
    },
    handleRoleClick (e) {
      this.$emit('roleSwitch', e.key)
    },
    handleLogout () {
      let url = process.env.NODE_ENV === 'production'
          ? '/common/logout.do'
          : '/api/common/logout.do'
      window.location.href = url
    }
  }
}
</script>
